import { useState, useEffect, useCallback } from "react";

/**
 * Returns true when the page has been scrolled past the given threshold (px).
 */
export const useScrolled = (threshold = 50): boolean => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > threshold);
  }, [threshold]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return scrolled;
};
